import { AppState } from "../../state";

export const isTakeawayEnabled = ({ location }: AppState) => {
    if (location.status !== "loaded") return false;
    return location.data.takeawayOptions.enabled;
};
